import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

export default({data}) => (
    <Grid data-testid="team-address" item style={{paddingBottom: '12px'}}>
        {data &&
        (data.teamStreetAddress ||
            data.teamCity ||
            data.teamState ||
            data.teamCountry ||
            data.teamPostalCode) && (<div>
        <Typography variant="body2">
            {data.teamStreetAddress}{' '}
            {data.teamCity}{' '}
            {data.teamState}{' '}
            {data.teamCountry}{' '}
            {data.teamPostalCode}{' '}</Typography>
        <Typography variant="body2">{data.teamPhoneNumber}</Typography></div>)}
    </Grid>
)